<!--
* @Name：供应商付款付款概况
* @Author: 刘玉
* @Date: 2021-12-02 15:43:41
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 15:43:41
-->
<template>
  <div>
    <hi-cell title="申请单号：" :value="paymentData.orderCode"></hi-cell>
    <hi-cell title="发起人：" :value="paymentData.crtUserName"></hi-cell>
    <van-cell>
      <span style="color: #909399; font-size: 17px">付款申请类型： </span>
      <span
        v-if="paymentData.paymentTypeCode == '02' || paymentData.paymentTypeCode == '04'"
        style="color: #ee0a24; font-size: 17px"
        >{{ paymentData.paymentTypeName }}</span
      >
      <span
        v-if="
          paymentData.paymentTypeCode == '01' ||
          paymentData.paymentTypeCode == '03' ||
          paymentData.paymentTypeCode == '05'
        "
        style="font-size: 17px"
        >{{ paymentData.paymentTypeName }}</span
      >
    </van-cell>
    <hi-cell title="公司名称：" :value="paymentData.companyName"></hi-cell>
    <hi-cell title="申请总金额：" :value="paymentData.applyAmountTotal"></hi-cell>
    <hi-cell title="币种：" :value="paymentData.currency" :options="currencyOptions"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'PaymentSituation',
  components: {},
  data() {
    return {}
  },
  props: {
    paymentData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    currencyOptions() {
      return this.$store.getters.dicts.currency_dict
    }
  }
}
</script>
